import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="dark-header">
      <div className="header-content">
        <div className="header-logo">
          <span className="logo-text">$KIM</span>
        </div>

        {/* Desktop Navigation */}
        <nav className="dark-nav desktop-nav">
          <button onClick={() => scrollToSection('about')} className="dark-nav-link">
            About
          </button>
          <button onClick={() => scrollToSection('tokenomics')} className="dark-nav-link">
            Tokenomics
          </button>
          <button onClick={() => scrollToSection('roadmap')} className="dark-nav-link">
            Roadmap
          </button>
          <button onClick={() => scrollToSection('memes')} className="dark-nav-link">
            Memes
          </button>
          <button onClick={() => scrollToSection('community')} className="dark-nav-link">
            Community
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-button"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <nav className="mobile-nav">
          <button onClick={() => scrollToSection('about')} className="mobile-nav-link">
            About
          </button>
          <button onClick={() => scrollToSection('tokenomics')} className="mobile-nav-link">
            Tokenomics
          </button>
          <button onClick={() => scrollToSection('roadmap')} className="mobile-nav-link">
            Roadmap
          </button>
          <button onClick={() => scrollToSection('memes')} className="mobile-nav-link">
            Memes
          </button>
          <button onClick={() => scrollToSection('community')} className="mobile-nav-link">
            Community
          </button>
        </nav>
      )}
    </header>
  );
};

export default Header;
